/**
 * DOS518 — Integrazione ASTUTO
 * adapters/index.ts — Factory + barrel.
 */

export { RestAdapter }      from './restAdapter';
export { FileAdapter }      from './fileAdapter';
export { ClipboardAdapter } from './clipboardAdapter';
export { MockAdapter }      from './mockAdapter';
export type { AstutoAdapter } from './baseAdapter';

import type { AstutoMode } from '../types';
import type { AstutoAdapter } from './baseAdapter';
import { RestAdapter }      from './restAdapter';
import { FileAdapter }      from './fileAdapter';
import { ClipboardAdapter } from './clipboardAdapter';
import { MockAdapter }      from './mockAdapter';

export function getAdapter(mode: AstutoMode): AstutoAdapter {
  switch (mode) {
    case 'rest':      return new RestAdapter();
    case 'file':      return new FileAdapter();
    case 'clipboard': return new ClipboardAdapter();
    case 'disabled':
    default:          return new MockAdapter();
  }
}
